import type { ImageLabel } from '../types/LabelingTypes';

/*
 * The labelize state tokens (`ok` / `worn` / `unreadable`, see index.css) as full literal class
 * strings, so Tailwind can statically pick them up.
 */

/** Solid state colour: dots, swatches, confidence bars. */
export const LABEL_FILL: Record<ImageLabel, string> = {
  ok: 'bg-ok',
  worn: 'bg-worn',
  unreadable: 'bg-unreadable',
};

/** State colour as text. */
export const LABEL_TEXT: Record<ImageLabel, string> = {
  ok: 'text-ok',
  worn: 'text-worn',
  unreadable: 'text-unreadable',
};

/** Ring-coloured border around a state surface. */
export const LABEL_BORDER: Record<ImageLabel, string> = {
  ok: 'border-ok-ring',
  worn: 'border-worn-ring',
  unreadable: 'border-unreadable-ring',
};

/** AI suggestion strip: state-coloured left edge on the soft state background. */
export const LABEL_STRIP: Record<ImageLabel, string> = {
  ok: 'border-l-[3px] border-l-ok bg-ok-soft',
  worn: 'border-l-[3px] border-l-worn bg-worn-soft',
  unreadable: 'border-l-[3px] border-l-unreadable bg-unreadable-soft',
};
